/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
import Echo from 'laravel-echo'
import { safeGetItem } from '@/helpers/safeLocalStorage'
import { EchoChat } from '@/plugins/chat'

const token = safeGetItem('token')

window.axios = require('axios').default
window.axios.defaults.headers.common['Authorization'] = token

window.io = require('socket.io-client')

window.Echo = new Echo({
  broadcaster: 'socket.io',
  host: process.env.BROADCAST_SERVER,
  auth: {
    headers: {
      Authorization: token,
    },
  },
})

window.EchoChat = null

const chat = new Promise(resolve => resolve(EchoChat()))

chat.then(chat => {
  window.EchoChat = chat
})
